import { DeviceInfo } from "ngx-device-detector";

export class ClientDeviceInfo implements DeviceInfo {
    isDesktopMode: boolean = false;
    userAgent: string = '';
    os: string = ''
    browser: string = '';
    device: string = '';
    os_version: string = '';
    browser_version: string = '';
    deviceType: string = '';
    orientation: string = '';
    brand: string = '';
    model: string = '';

    languages: string[] = [];
    processors: number = 0;

    timeZone: string = '';
    calendar: string = '';

    private desktop: boolean = false;
    private tablet: boolean = false;
    private mobile: boolean = false;

    private clientDeviceFingerprint: string = '';

    constructor() {}

    public fromDeviceInfo(deviceInfo: DeviceInfo, isDesktop: boolean, isTablet: boolean, isMobile: boolean): void {
        this.device = deviceInfo.device;
        this.deviceType = deviceInfo.deviceType;
        this.os = deviceInfo.os;
        this.os_version = deviceInfo.os_version;
        this.browser = deviceInfo.browser;
        this.browser_version = deviceInfo.browser_version;
        this.orientation = deviceInfo.orientation;
        this.userAgent = deviceInfo.userAgent;

        this.desktop = isDesktop;
        this.tablet = isTablet;
        this.mobile = isMobile;

        this.languages = [...navigator.languages];
        this.processors = navigator.hardwareConcurrency;

        this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.calendar = Intl.DateTimeFormat().resolvedOptions().calendar;

        // this.clientDeviceFingerprint = `${this.userAgent.substring(0, this.userAgent.indexOf(')') + 1)}-${this.deviceType}-${this.os_version}-${this.browser}-${this.browser_version.substring(0, this.browser_version.indexOf('.'))}-${this.languages}-${this.processors}-${this.timeZone}`;
        this.clientDeviceFingerprint = `${this.userAgent.substring(0, this.userAgent.indexOf(')') + 1)} -_- ${this.deviceType} -_- ${this.os_version} -_- ${this.browser} -_- ${this.browser_version.substring(0, this.browser_version.indexOf('.'))} -_- ${this.languages} -_- ${this.processors} -_- ${this.timeZone}`;
        const mySubstring = this.userAgent.substring(0, this.userAgent.indexOf(')'));
        this.model = mySubstring.substring(mySubstring.lastIndexOf('; ') + 1, mySubstring.lastIndexOf(')'));
        // console.log("-" + this.model + "-");
    }

    static logNavigatorProperties(): void {
        console.log("Windows.navigator properties:");
        console.log("clipboard: ", navigator.clipboard);
        console.log("cookieEnabled: " + navigator.cookieEnabled);
        console.log("credentials: ",  navigator.credentials);
        console.log("doNotTrack: " + navigator.doNotTrack);
        // navigator.geolocation.getCurrentPosition(
        //     (position) => console.log("navigator.geolocation.getCurrentPosition(success): ", position),
        //     (error) => console.log("navigator.geolocation.getCurrentPosition(error): ", error)
        // );
        // navigator.geolocation.watchPosition( (position) => console.log("navigator.geolocation.watchPosition(success): ", position), (error) => console.log("navigator.geolocation.watchPosition(error): ", error) );
        console.log("hardwareConcurrency: " + navigator.hardwareConcurrency);
        console.log("language: " + navigator.language);
        console.log("languages: " + navigator.languages);
        console.log("locks: ", navigator.locks);
        console.log("maxTouchPoints: " + navigator.maxTouchPoints);
        console.log("mediaCapabilities: ", navigator.mediaCapabilities);
        console.log("mediaDevices: ", navigator.mediaDevices);
        console.log("mediaSession: ", navigator.mediaSession);
        console.log("onLine: " + navigator.onLine);
        console.log("pdfViewerEnabled: " + navigator.pdfViewerEnabled);
        console.log("permissions: ", navigator.permissions);
        console.log("serviceWorker: ", navigator.serviceWorker);
        console.log("storage: ", navigator.storage);
        console.log("userActivation: ", navigator.userActivation);
        console.log("userAgent: " + navigator.userAgent);
        console.log("wakeLock: ", navigator.wakeLock);
        console.log("webdriver: " + navigator.webdriver);
        console.log("");
        console.log("Intl. properties");
        console.log("Intl.DateTimeFormat().resolvedOptions().timeZone: " + Intl.DateTimeFormat().resolvedOptions().timeZone);
        console.log("Intl.getCanonicalLocales(): " + Intl.getCanonicalLocales());
        console.log("Intl.NumberFormat().format(10): " + Intl.NumberFormat().format(10));
        // console.log("Intl.PluralRules().resolvedOptions(): " + Intl.PluralRules().resolvedOptions());
        // console.log("Intl.PluralRules().select(10)): " + Intl.PluralRules().select(10));
        console.log("Intl.getCanonicalLocales(): " + Intl.getCanonicalLocales());
        console.log("Intl.Collator().compare(\"10\", \"20\"): " + Intl.Collator().compare("10", "20"));
        console.log("Intl.DateTimeFormat().format(): " + Intl.DateTimeFormat().format());
        console.log("Intl.DateTimeFormat().formatToParts(): ", Intl.DateTimeFormat().formatToParts());
        console.log("Intl.DateTimeFormat().resolvedOptions().calendar: " + Intl.DateTimeFormat().resolvedOptions().calendar);
        console.log("Intl.DateTimeFormat().resolvedOptions().dateStyle: " + Intl.DateTimeFormat().resolvedOptions().dateStyle);
        console.log("Intl.DateTimeFormat().resolvedOptions().day: " + Intl.DateTimeFormat().resolvedOptions().day);
        console.log("Intl.DateTimeFormat().resolvedOptions().dayPeriod: " + Intl.DateTimeFormat().resolvedOptions().dayPeriod);
        console.log("Intl.DateTimeFormat().resolvedOptions().era: " + Intl.DateTimeFormat().resolvedOptions().era);
        console.log("Intl.DateTimeFormat().resolvedOptions().formatMatcher: " + Intl.DateTimeFormat().resolvedOptions().formatMatcher);
        console.log("Intl.DateTimeFormat().resolvedOptions().fractionalSecondDigits: " + Intl.DateTimeFormat().resolvedOptions().fractionalSecondDigits);
        console.log("Intl.DateTimeFormat().resolvedOptions().hour12: " + Intl.DateTimeFormat().resolvedOptions().hour12);
        console.log("Intl.DateTimeFormat().resolvedOptions().hour: " + Intl.DateTimeFormat().resolvedOptions().hour);
        console.log("Intl.DateTimeFormat().resolvedOptions().hourCycle: " + Intl.DateTimeFormat().resolvedOptions().hourCycle);
        console.log("Intl.DateTimeFormat().resolvedOptions().locale: " + Intl.DateTimeFormat().resolvedOptions().locale);
        console.log("Intl.DateTimeFormat().resolvedOptions().minute: " + Intl.DateTimeFormat().resolvedOptions().minute);
        console.log("Intl.DateTimeFormat().resolvedOptions().month: " + Intl.DateTimeFormat().resolvedOptions().month);
        console.log("Intl.DateTimeFormat().resolvedOptions().numberingSystem): " + Intl.DateTimeFormat().resolvedOptions().numberingSystem);
        console.log("Intl.DateTimeFormat().resolvedOptions().second): " + Intl.DateTimeFormat().resolvedOptions().second);
        console.log("Intl.DateTimeFormat().resolvedOptions().timeStyle): " + Intl.DateTimeFormat().resolvedOptions().timeStyle);
        console.log("Intl.DateTimeFormat().resolvedOptions().timeZone): " + Intl.DateTimeFormat().resolvedOptions().timeZone);
        console.log("Intl.DateTimeFormat().resolvedOptions().timeZoneName): " + Intl.DateTimeFormat().resolvedOptions().timeZoneName);
        console.log("Intl.DateTimeFormat().resolvedOptions().weekday): " + Intl.DateTimeFormat().resolvedOptions().weekday);
        console.log("Intl.DateTimeFormat().resolvedOptions().year): " + Intl.DateTimeFormat().resolvedOptions().year);
    }

    public isDesktop(): boolean {
        return this.desktop;
    }

    public isTablet(): boolean {
        return this.tablet;
    }

    public isMobile(): boolean {
        return this.mobile;
    }

    public getClientDeviceFingerprint(): string {
        return this.clientDeviceFingerprint;
    }

/***************************
navigator.hardwareConcurrency (CPU cores)

navigator.deviceMemory (RAM estimate)




navigator.language

Normalize OS and browser versions (e.g., just major version)

************************************ */
}